export default __webpack_public_path__ + "e99a752d537d539a67176469945f0763.png";